.heading {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid rgb(var(--ng-neutral-10));
    padding-bottom: var(--ng-gp-8);
    margin-bottom: var(--ng-gp-8);
}

.heading img {
    cursor: pointer;
}

.listWrapper{
    display: flex;
    flex-direction: column;
    gap: var(--ng-gp-6);
    height: 100%;
    overflow: auto;
}

.listItem {
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    min-height: 28px;
    border-radius: var(--ng-rd-4);
    padding: var(--ng-gp-4);
}

.listItem:hover {
    background: rgb(var(--ng-neutral-10));
    cursor: pointer;
}

.parentWrapper{
    display: flex;
    flex-direction: column;
    height: 100%;
}

.shimmerWrapper{
    margin-bottom: var(--ng-gp-6);
}

.shimmerWrapper:last-child {
    margin-bottom: 0;
}

.illustrationWrapper{
    display: flex;
    flex-direction: column;
    height: 100%;
    align-items: center;
    justify-content: center;
    gap: var(--ng-gp-6);
}

.subHeading{
    margin-top: var(--ng-gp-8);
}

.retryButton{
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--ng-gp-4);
    width: 80px;
    height: 26px;
    color: rgb(var(--ng-neutral-white));
    background: rgb(var(--ng-neutral-70));
    border-radius: var(--ng-rd-6);
    cursor: pointer;
}